import axiosInstance from "../api/axiosInstance";

/**
 * Fetch all subscriptions for a user
 * @param {number} userId
 */
export const fetchUserSubscriptions = async () => {

 const response = await axiosInstance.get(
 `/user-subscriptions/all`
 );


 return response.data || [];
};
